// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__n1_NY","colMaxWidth":"Table_colMaxWidth__3Vu0s"};